import { AgendaModulesTable } from "@/components/agendaModules/AgendaModulesTable";
import { CreateAgendaModuleDialog } from "@/components/agendaModules/CreateAgendaModuleDialog";
import { RoleProtected } from "@/components/common/RoleProtected";
import { PageHeader } from "@/components/page";
import { useGetTenantByFriendly } from "@/hooks/queryHooks/tenantHooks";
import { useRoleProtected } from "@/hooks/useRoleProtected";
import { useUserStore } from "@/stores/userStore";
import { DataTableWrapper } from "@repo/ui/components/Base/DataTable";
import { useParams } from "react-router-dom";

export const AgendaModulesPage = () => {
  const { tenantId } = useParams();
  const activeTeam = useUserStore((s) => s.activeTeam);
  useRoleProtected("edit");
  const { loaded: tenantLoaded, data: tenantData } = useGetTenantByFriendly(
    tenantId ?? ""
  );

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader
        title={
          tenantData?.name
            ? `${tenantData.name}'s Agenda Sections`
            : "Agenda Sections"
        }
      >
        {activeTeam === "org" && (
          <p className="text-red-500 w-0 flex-grow-[3] mr-8 text-balance text-right">
            You must select a team to be able to edit and create sections, and
            access linked agendas and items.
          </p>
        )}
        {tenantData?.id && (
          <RoleProtected minRole="edit">
            <CreateAgendaModuleDialog
              isTemplate
              tenantId={tenantData.id}
              disabled={activeTeam === "org"}
            />
          </RoleProtected>
        )}
      </PageHeader>
      {!tenantLoaded && <div>Loading ... </div>}

      {tenantLoaded && tenantData?.id && (
        <DataTableWrapper>
          <AgendaModulesTable tenantId={tenantData.id} />
        </DataTableWrapper>
      )}
    </div>
  );
};
